import { render, staticRenderFns } from "./RadioString.vue?vue&type=template&id=674f21b8&scoped=true&"
import script from "./RadioString.vue?vue&type=script&lang=js&"
export * from "./RadioString.vue?vue&type=script&lang=js&"
import style0 from "./RadioString.vue?vue&type=style&index=0&id=674f21b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674f21b8",
  null
  
)

export default component.exports